<ng-template #contentTpl><ng-content /></ng-template>